import React, { useEffect } from "react";
import confetti from "canvas-confetti";

export function fireConfetti(intensity = "normal") {
  const presets = {
    soft: { particleCount: 80, spread: 60, startVelocity: 30 },
    normal: { particleCount: 140, spread: 80, startVelocity: 45 },
    strong: { particleCount: 220, spread: 100, startVelocity: 55 },
  };
  const opts = presets[intensity] || presets.normal;
  confetti({
    ...opts,
    origin: { y: 0.45 },
    colors: ["#F39024", "#FFC979", "#2D5C7E", "#3B6D11", "#FFFFFF"],
  });
}

export default function ConfettiOnMount({ intensity = "normal" }) {
  useEffect(() => {
    fireConfetti(intensity);
  }, [intensity]);
  return null;
}
